<template>
    <div class="pa-5" v-if="activeExtProductPrice">
        <!-- ExtProduct -->
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Name" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{
                    activeExtProductPrice.ext_product && activeExtProductPrice.ext_product.name
                        ? activeExtProductPrice.ext_product.name
                        : "-"
                }}
            </v-col>
        </v-row>

        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Weight" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{
                    activeExtProductPrice.ext_product && activeExtProductPrice.ext_product.weight
                        ? activeExtProductPrice.ext_product.weight
                        : "-"
                }}
            </v-col>
        </v-row>

        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "EAN" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{
                    activeExtProductPrice.ext_product_code && activeExtProductPrice.ext_product_code.ean
                        ? activeExtProductPrice.ext_product_code.ean
                        : "-"
                }}
            </v-col>
        </v-row>

        <!-- related_product -->

        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Related product" | t }}</v-col>
            <v-col class="col-item" cols="6" v-if="activeExtProductPrice.related_product">
                <span class="clickable-text" @click="redirectToProduct(activeExtProductPrice.related_product.id)">
                    {{ activeExtProductPrice.related_product.name ? activeExtProductPrice.related_product.name : "-" }}
                </span>
            </v-col>
            <v-col class="col-item" cols="6" v-else>
                -
            </v-col>
        </v-row>

        <v-divider class="my-2" />

        <!-- ExtProductPrice / Shop -->

        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Shop" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{
                    activeExtProductPrice.shop && activeExtProductPrice.shop.name
                        ? activeExtProductPrice.shop.name
                        : "-"
                }}
            </v-col>
        </v-row>

        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Original price" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeExtProductPrice.original_price ? activeExtProductPrice.original_price : "-" }}
            </v-col>
        </v-row>

        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Discount price" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeExtProductPrice.discount_price ? activeExtProductPrice.discount_price : "-" }}
            </v-col>
        </v-row>

        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Visited at" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeExtProductPrice.visited_at ? formatDateTime(activeExtProductPrice.visited_at) : "-" }}
            </v-col>
        </v-row>

        <v-divider class="my-2" />

        <!--additional_data-->
        <v-row v-if="activeExtProductPrice.additional_data && activeExtProductPrice.additional_data.length > 0">
            <v-col class="col-item row-title" cols="12">{{ "Price history" | t }}</v-col>

            <v-simple-table style="width: 100%">
                <template v-slot:default>
                    <thead>
                        <tr>
                            <th class="text-left">{{ "Shop" | t }}</th>
                            <th class="text-left">{{ "EAN" | t }}</th>
                            <th class="text-left">{{ "Original price" | t }}</th>
                            <th class="text-left">{{ "Discount price" | t }}</th>
                            <th class="text-left">{{ "Visited at" | t }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="data in activeExtProductPrice.additional_data"
                            :key="data.price_id"
                            :class="{
                                activeTableRow:
                                    parseInt(data.price_id) === parseInt(activeExtProductPrice.id) &&
                                    activeExtProductPrice.additional_data.length > 1
                            }"
                        >
                            <td>{{ data.shop.name }}</td>
                            <td>{{ data.ext_product_code.ean }}</td>
                            <td>{{ data.original_price }}</td>
                            <td>{{ data.discount_price }}</td>
                            <td>{{ formatDateTime(data.visited_at) }}</td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-row>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
    name: "general-view",
    data() {
        return {};
    },
    computed: {
        ...mapState("ExtProductStore", ["activeExtProductPrice"])
    },
    methods: {
        redirectToProduct(productId) {
            this.$router.push({ name: "product-view", params: { productId } });
        },
        formatDateTime(dateTimeString) {
            const dateTime = new Date(dateTimeString);

            const hours = dateTime
                .getHours()
                .toString()
                .padStart(2, "0");
            const minutes = dateTime
                .getMinutes()
                .toString()
                .padStart(2, "0");
            const day = dateTime
                .getDate()
                .toString()
                .padStart(2, "0");
            const month = (dateTime.getMonth() + 1).toString().padStart(2, "0");
            const year = dateTime.getFullYear().toString();

            return `${day}.${month}.${year}  -  ${hours}:${minutes}`;
        }
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}

.col-item {
    padding-top: 8px;
    padding-bottom: 8px;
}

.clickable-text {
    color: #f41823;
    text-decoration: underline;
    cursor: pointer;
}
</style>
